import { ca } from '@cian/analytics';

import { IPageState } from '../../types/page';
import { IFavoriteEntity } from '../../types/results';
import { TUser } from '../../types/user';
import { getProduct, getPageNumber } from '../../utils/trackings';

/**
 * Клик на кнопку перейти в ЖК
 */
export function trackGoJKClick(
  pageData: IPageState,
  user: TUser,
  entityId: number,
  favoriteEntities: IFavoriteEntity[],
  total: number,
) {
  const product = getProduct(entityId, favoriteEntities);

  ca('eventEbc', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'to_card',
    label: 'card_button',
    user: {
      isAuthorized: user.isAuthenticated,
      userId: user.isAuthenticated ? user.userId : undefined,
    },
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, product.position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: pageData.deviceType === 'phone' ? 'mobile' : pageData.deviceType,
    },
    products: [product],
  });
}
